import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RequestRoleResponse } from "@/types";
import { httpRequest } from "@/lib";

type RoleRequestDTO = {
  name: string;
};

async function createRole(
  request: RoleRequestDTO
): Promise<RequestRoleResponse> {
  const response = await httpRequest.post<RequestRoleResponse>(
    "/positions",
    request
  );
  return response.data;
}

export function useCreateRoleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["positions"] });
    },
  });
}
